export default __webpack_public_path__ + "static/media/shrek.e20477a9.png";